import * as React from 'react'
import { cn } from '@/lib/utils'

function Card({
  className,
  interactive = false,
  selected = false,
  ...props
}: React.ComponentProps<'div'> & {
  interactive?: boolean
  selected?: boolean
}) {
  return (
    <div
      data-slot='card'
      data-selected={selected || undefined}
      className={cn(
        // jobsvox "paper" surface: 16px radius, hairline border, warm resting shadow
        'flex flex-col gap-6 rounded-card border bg-card py-6 text-card-foreground shadow-card transition-[box-shadow,transform] duration-200 ease-[var(--ss-ease)]',
        interactive &&
          'cursor-pointer hover:-translate-y-0.5 hover:shadow-raised',
        selected && 'bg-secondary shadow-[inset_0_0_0_1.5px_var(--ss-sel)]',
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-header'
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
        className
      )}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-title'
      className={cn('font-display leading-none font-semibold', className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-description'
      className={cn('text-sm text-muted-foreground', className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-action'
      className={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-content'
      className={cn('px-6', className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-footer'
      className={cn('flex items-center px-6 [.border-t]:pt-6', className)}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
